<template lang="html">
  <div class="province-F">
    <!-- <div class="ttBar">
      <span>人员情况统计</span>
      getWorkerStatisticList
    </div> -->
    <div class="tabArea">
      <div class="seekArea">
        <div class="selectBox">
          <span>资质：</span>
          <el-select v-model="selType" size="small" placeholder="请选择" style="width: 80px">
            <el-option v-for="item in Zizhi" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <span>省局：</span>
          <el-select v-model="selProvinceId" size="small" placeholder="请选择" clearable style="width: 230px">
            <el-option
              v-for="item in Shengju"
              :key="item.sjExamineId"
              :label="item.sjExamine"
              :value="item.sjExamineId">
            </el-option>
          </el-select>
        </div>
        <!-- <div class="selectBox">
          <span>排序： </span>
          <el-select v-model="selOrder" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for="item in OrderBy" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
          <el-select v-model="selSort" size="small" placeholder="请选择" clearable @change="tabSeek">
            <el-option v-for="item in Sort" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div> -->
        <div class="selectBox">
          <span>年份：</span>
          <el-select v-model="selYear" size="small" placeholder="历年记录" style="width: 120px">
            <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="selectBox">
          <el-button size="small" type="primary" @click="goSeek" :loading="loading">搜索</el-button>
          <el-button size="small" type="primary" plain style="margin-left: 10px" @click="goExport">导出</el-button>
        </div>
      </div>
      <el-table
        :data="tabDats"
        border
        style="width: 100%"
        @sort-change="this.handleSortChange"
        :height="this.tableHeight">
        <el-table-column prop="organizationName" label="出版单位" min-width="100" align="center" fixed>
        </el-table-column>
        <el-table-column prop="provinceName" label="所属省局" align="center"> </el-table-column>
        <el-table-column prop="workers" label="单位职工总数" align="center" sortable="custom"> </el-table-column>
        <el-table-column
          prop="businessWorkers"
          label="从事电子出版物业务人员数"
          width="230"
          align="center"
          sortable="custom">
        </el-table-column>
        <el-table-column prop="otherWorkers" label="其他人员数" align="center" sortable="custom"> </el-table-column>
        <el-table-column prop="leaderWorkers" label="领导班子人员数" align="center" sortable="custom">
        </el-table-column>
        <el-table-column prop="leaderWorkerProportion" label="领导班子持证上岗率" align="center" sortable="custom">
        </el-table-column>
        <el-table-column
          prop="zjCertificateWorkers"
          label="出版专业中级职称及以上人数"
          width="144"
          align="center"
          sortable="custom">
        </el-table-column>
      </el-table>

      <div class="pageCage" v-if="params.pgAll > 1">
        <el-pagination
          @current-change="pageSent"
          :current-page="params.no"
          layout="prev, pager, next"
          :page-count="params.pgAll">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getProviceList, getWorkerStatisticList } from "@/api/adminRole/adminRole";
import { getSelYearRecord } from "@/api/pressRole/pressRole";
import { outExcel } from "@/utils/Export";

export default {
  data() {
    return {
      selType: "1",
      Zizhi: [
        {
          value: "1",
          label: "音像",
        },
        {
          value: "2",
          label: "电子",
        },
      ],

      selProvinceId: undefined,
      Shengju: [],

      selOrder: undefined,
      OrderBy: [
        {
          value: "workers",
          label: "单位职工总数",
        },
        {
          value: "businessWorkers",
          label: "从事电子出版物业务人员数",
        },
        {
          value: "otherWorkers",
          label: "其他人员数",
        },
        {
          value: "leaderWorkers",
          label: "领导班子总人数",
        },
        {
          value: "leaderWorkerProportion",
          label: "领导班子持证上岗率",
        },
        {
          value: "zjCertificateWorkers",
          label: "出版专业中级职称以上人数",
        },
      ],

      selSort: "asc",
      Sort: [
        {
          value: "asc",
          label: "正序",
        },
        {
          value: "desc",
          label: "倒序",
        },
      ],

      selYear: "",
      tabDats: [],
      params: {
        year1: "",
      },
      tableHeight: 250,
    };
  },

  methods: {
    tabSeek: function (type) {
      this.loading = true;
      this.params = {
        type: this.selType,
        provinceId: this.selProvinceId,
        order: this.selOrder,
        sort: this.selSort,
        year: this.selYear,
      };
      let vm = this;

      getWorkerStatisticList(this.params).then((response) => {
        console.debug("getWorkerStatisticList: ", response);

        setTimeout(function () {
          vm.loading = false;
          vm.tabDats = response.workerStatisticList;
        }, 300);
      });
    },
    handleSortChange: function (column) {
      this.selOrder = column.prop;

      var sort = undefined;
      if (column.order == "ascending") {
        sort = 1;
      } else if (column.order == "descending") {
        sort = 0;
      }
      this.selSort = sort;
      console.log(this.selOrder, this.selSort, column);
      this.tabSeek();
    },
    goFirm: function (rows) {
      this.$router.push({
        path: "successive_skim",
        query: {
          pressId: rows.organizationId,
          pvcName: rows.sjExamine,
          pvcId: rows.sjExamineId,
          listId: rows.id,
          bookName: rows.name,
          pressName: rows.organizationName,
          mtId: rows.materialExamineId,
          examId: rows.materialExamineId,
          pressState: 3,
          year1: this.selYear,
        },
      });
    },
    pageSent: function (inx) {
      this.params.no = inx;
      this.tabSeek();
    },
    goSeek: function () {
      this.params.no = 1;
      this.params.year1 = this.selYear || "";
      this.pgAll = 0;
      this.tabSeek();
    },

    provinceSet: function () {
      let vm = this;
      getProviceList({
        type: this.selType,
      }).then((response) => {
        vm.Shengju = response.proList;
      });
    },
    getHeight() {
      var header = document.getElementsByClassName("seekArea")[0].clientHeight;
      console.log("Resize:", header);
      this.tableHeight = document.documentElement.clientHeight - header - 120;

      console.log("Resize:", this.tableHeight);
    },
    goExport: function () {
      var that = this;
      var params = {
        type: this.selType,
        // provinceId: this.selProvinceId,
        // order: this.selOrder,
        // sort: this.selSort,
        year: this.selYear,
      };
      getWorkerStatisticList(this.params).then((response) => {
        var filename = "人员情况统计";
        var cols = [
          {
            dataIndex: "organizationName",
            title: "出版单位",
            width: 180,
          },
          {
            dataIndex: "provinceName",
            title: "所属省局",
            width: 180,
          },
          {
            dataIndex: "workers",
            title: "单位职工总数",
            width: 120,
          },
          {
            dataIndex: "businessWorkers",
            title: "从事电子出版物业务人员数",
            width: 230,
          },
          {
            dataIndex: "otherWorkers",
            title: "其他人员数",
            width: 120,
          },
          {
            dataIndex: "leaderWorkers",
            title: "领导班子总人数",
            width: 120,
          },
          {
            dataIndex: "leaderWorkerProportion",
            title: "领导班子持证上岗率",
            width: 150,
          },
          {
            dataIndex: "zjCertificateWorkers",
            title: "出版专业中级职称以上人数",
            width: 200,
          },
        ];
        var wsname = "人员情况统计";
        outExcel(response.workerStatisticList, cols, filename, wsname);
      });
    },
  },

  created: function () {
    this.provinceSet();
    getSelYearRecord({
      publishId: "",
      type: 3,
    }).then((response) => {
      console.log("======", response);
      var arr = [];
      if (response.generalPublisher.length > 0) {
        for (var i in response.generalPublisher) {
          var po = response.generalPublisher[i];
          arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
          if (response.generalPublisher.length - 1 == i) {
            this.params.year1 = po.firstYear;
            this.selYear = po.firstYear;
          }
        }
      }
      this.selYearRecord = arr;
      this.tabSeek();
    });
    window.addEventListener("resize", this.getHeight);
  },
  mounted: function () {
    this.$nextTick(() => {
      this.getHeight();
    });
  },
  destroyed: function () {
    window.removeEventListener("resize", this.getHeight);
  },
};
</script>

<style lang="scss" scoped>
.province-F {
  padding: 9px;

  .ttBar {
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    font-size: 14px;
    padding: 0 20px;
    color: #666666;
    font-weight: bold;
  }

  .tabArea {
    margin-top: 12px;

    .seekArea {
      margin-bottom: 12px;
      overflow: hidden;
      .selectBox {
        padding-left: 10px;
        float: left;
      }

      .el-input {
        width: 120px;

        input {
          border-radius: 0px;
        }
      }
    }

    .pageCage {
      text-align: center;
      margin: 30px auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// adminPersonOperation.vue?5d379a9b